export enum ToastMessageType {
  success = 'success',
  info = 'info',
  warn = 'warn',
  error = 'error'
}
